module.exports = __webpack_public_path__ + "static/media/step3_lender.54167732.png";